import "./Portfolio.module.css";
import Header from "@/reusable_sections/Header";
import PortfolioGallery from "./sections/PortfolioGallery";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function PortfolioPage() {
  return <div>
      <Header />
      <PortfolioGallery />
      <CallToAction />
      <Footer />
    </div>;
}